import Availabilities from 'reservations/availabilities/components/Availabilities';
import { MaxPartySizeText } from 'reservations/availabilities/components/MaxPartySizeText';
import { useIsBeyondMaxPartySize } from 'reservations/availabilities/hooks/useIsBeyondMaxPartySize';

function AvailabilitiesContainer() {
  const isBeyondMaxPartySize = useIsBeyondMaxPartySize();
  return isBeyondMaxPartySize ? <MaxPartySizeText /> : <Availabilities />;
}

export default AvailabilitiesContainer;
